import { Box, Button, Typography, Card } from "@mui/material";
import { Images } from "../../../../helpers/Images";
import { useNavigate } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { categoriesData } from "../../../../helpers/Arrays";
import { isMobile } from "react-device-detect";
import "./CategoriesCarousel.css";

const CategoriesCarousel = () => {
  const navigate = useNavigate();
  return (
    <Box
      className="categories-section"
      sx={{
        width: "100%",
        backgroundColor: "primary.main",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1500px",
          padding: {
            xs: "50px 20px 100px 20px",
            sm: "50px 60px",
            lg: "70px 120px",
          },
          margin: "auto",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: { xs: "center", sm: "space-between" },
            gap: { xs: "10px", sm: "0" },
            alignItems: "center",
            marginBottom: "24px",
          }}
        >
          <Box sx={{ width: "100%" }}>
            <Typography
              variant="h2"
              className="categories-title"
              sx={{
                textAlign: { xs: "center", sm: "start" },
                fontSize: { xs: "32px", sm: "42px" },
                fontWeight: "700",
                color: "secondary.main",
                marginBottom: "8px",
                letterSpacing: "-0.5px",
                textShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
                width: "100%",
              }}
            >
              IRC Categories
            </Typography>
            <Box
              sx={{
                height: "4px",
                width: { xs: "120px", md: "150px" },
                background: {
                  xs: "linear-gradient(90deg, transparent,#fff, transparent)",
                  sm: "linear-gradient(90deg, #fff, transparent)",
                },
                margin: { xs: "0 auto", sm: "0" },
                borderRadius: "2px",
                // boxShadow: "0 0 10px rgba(255, 255, 255, 0.5)",
              }}
            />
          </Box>
          <Button
            variant="contained"
            color="secondary"
            href="/categories"
            sx={{
              fontSize: { xs: "14px", sm: "16px" },
              fontWeight: "600",
              color: "primary.main",
              padding: { xs: "10px 28px", sm: "12px 36px" },
              borderRadius: "30px",
              textTransform: "none",
              letterSpacing: "0.5px",
              boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              minWidth: "230px",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 6px 24px rgba(0, 0, 0, 0.3)",
                backgroundColor: "rgba(255, 255, 255, 0.95)",
              },
            }}
          >
            View All Categories
          </Button>
        </Box>
        <Box
          sx={{
            width: "100%",
            margin: "auto",
            position: "relative",
          }}
        >
          <Carousel
            showStatus={false}
            showThumbs={false}
            showArrows={true}
            showIndicators={false}
            infiniteLoop={true}
            autoPlay={true}
            interval={4000}
            centerMode={isMobile ? false : true}
            centerSlidePercentage={50}
            className="categories-carousel"
            renderArrowPrev={(onClickHandler, hasPrev) => (
              <Box
                className={`carousel-arrow carousel-arrow-prev ${
                  hasPrev ? "active" : ""
                }`}
                onClick={onClickHandler}
                sx={{
                  width: { xs: "50px", md: "60px" },
                  height: { xs: "50px", md: "60px" },
                  cursor: "pointer",
                  position: "absolute",
                  zIndex: 2,
                  left: { xs: "10px", md: "-80px" },
                  top: { xs: "unset", md: "calc(50% - 30px)" },
                  bottom: { xs: "-70px", md: "unset" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  borderRadius: "50%",
                  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    transform: "scale(1.1)",
                    boxShadow: "0 6px 24px rgba(0, 0, 0, 0.3)",
                  },
                }}
              >
                <img
                  alt="prev"
                  src={Images.prevArrow}
                  style={{
                    width: "60%",
                    height: "60%",
                    filter:
                      "invert(13%) sepia(48%) saturate(5796%) hue-rotate(350deg) brightness(103%) contrast(93%)",
                  }}
                />
              </Box>
            )}
            renderArrowNext={(onClickHandler, hasNext) => (
              <Box
                className={`carousel-arrow carousel-arrow-next ${
                  hasNext ? "active" : ""
                }`}
                onClick={onClickHandler}
                sx={{
                  width: { xs: "50px", md: "60px" },
                  height: { xs: "50px", md: "60px" },
                  cursor: "pointer",
                  position: "absolute",
                  zIndex: 2,
                  right: { xs: "10px", md: "-80px" },
                  top: { xs: "unset", md: "calc(50% - 30px)" },
                  bottom: { xs: "-70px", md: "unset" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  borderRadius: "50%",
                  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    transform: "scale(1.1)",
                    boxShadow: "0 6px 24px rgba(0, 0, 0, 0.3)",
                  },
                }}
              >
                <img
                  alt="next"
                  src={Images.nextArrow}
                  style={{
                    width: "60%",
                    height: "60%",
                    filter:
                      "invert(13%) sepia(48%) saturate(5796%) hue-rotate(350deg) brightness(103%) contrast(93%)",
                  }}
                />
              </Box>
            )}
          >
            {categoriesData?.map((item, i) => (
              <Box key={i} sx={{ padding: { xs: "0 10px", md: "0 15px" } }}>
                <Card
                  className="category-card"
                  sx={{
                    backgroundImage: `linear-gradient(135deg, rgba(131, 13, 11, 0.6) 0%, rgba(0, 0, 0, 0.4) 100%), url(${item.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                    width: "100%",
                    minHeight: { xs: "320px", sm: "320px" },
                    borderRadius: "24px",
                    overflow: "hidden",
                    position: "relative",
                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                    cursor: "pointer",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background:
                        "linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 60%)",
                      opacity: 1,
                      transition: "opacity 0.4s ease",
                    },
                    "&:hover": {
                      boxShadow: "0 16px 48px rgba(0, 0, 0, 0.4)",
                      borderColor: "rgba(255, 255, 255, 0.3)",
                      "&::before": {
                        opacity: 0.9,
                      },
                      "& .category-title": {
                        transform: "translateY(-4px)",
                      },
                      "& .category-button": {
                        transform: "translateY(-4px) scale(1.05)",
                      },
                    },
                  }}
                  onClick={() => navigate(item.link)}
                >
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 1,
                      padding: { xs: "30px 20px", sm: "40px 30px" },
                    }}
                  >
                    <Typography
                      className="category-title"
                      variant="h3"
                      sx={{
                        textAlign: "center",
                        fontSize: { xs: "28px", sm: "32px", md: "36px" },
                        fontWeight: "700",
                        color: "secondary.main",
                        marginBottom: "12px",
                        textShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
                        transition:
                          "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                        letterSpacing: "-0.5px",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Box
                      sx={{
                        height: "4px",
                        maxWidth: "100px",
                        width: "100%",
                        background:
                          "linear-gradient(90deg, transparent, #fff, transparent)",
                        margin: "0 auto 24px auto",
                        borderRadius: "2px",
                        boxShadow: "0 0 10px rgba(255, 255, 255, 0.5)",
                      }}
                    />
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        className="category-button"
                        variant="contained"
                        color="secondary"
                        sx={{
                          fontSize: { xs: "13px", sm: "15px" },
                          fontWeight: "600",
                          color: "primary.main",
                          padding: { xs: "10px 32px", sm: "12px 40px" },
                          borderRadius: "30px",
                          textTransform: "none",
                          letterSpacing: "0.5px",
                          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.3)",
                          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                          "&:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.95)",
                            boxShadow: "0 6px 24px rgba(0, 0, 0, 0.4)",
                          },
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(item.link);
                        }}
                      >
                        View Details
                      </Button>
                    </Box>
                  </Box>
                </Card>
              </Box>
            ))}
          </Carousel>
        </Box>
      </Box>
    </Box>
  );
};

export default CategoriesCarousel;

// RobotChallenge is one of the biggest competitions for self-made, autonomous and mobile robots worldw
